<template>
  <svg
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Close cross sign icon</title>
    <path
      d="M14.0001 1.41L12.5901 0L7.00012 5.59L1.41012 0L0.00012207 1.41L5.59012 7L0.00012207 12.59L1.41012 14L7.00012 8.41L12.5901 14L14.0001 12.59L8.41012 7L14.0001 1.41Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'KIconClose'
}
</script>
